module.exports = __webpack_public_path__ + "static/Cookpy-ff3dbc8c3490d575194934c223503912.jpg";